import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'attributesToButtels'})

export class AttributesToButtels implements PipeTransform {
  transform(value: string): string {
  	if (typeof value !== "string") {
    	  return value;
  	}
  	var myString =  "<span class='inlineShow'>"+ value.replace(/; /g, "</span><span class='inlineShow'>") + "</span>";
  	return myString.replace("<span class='inlineShow'></span>", '');  	
  }
}